import React, { useMemo, useState } from "react";

import './Table.css';

const TimerInput = ({ value, onChange }) => {
    const [isTiming, setIsTiming] = useState(false);
    const [animKey, setAnimKey] = useState(0);

    const handleChange = (e) => {
        setIsTiming(true);
        setAnimKey(prev => prev + 1);
        onChange(e);
    };

    return (
        <div style={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center' }}>
            <input
                style={{ width: '100%', paddingRight: 28, padding: 4 }}
                onChange={handleChange}
                value={value}
            />
            {isTiming && (
                <svg key={animKey} width="20" height="20" style={{ position: 'absolute', right: 6 }}>
                    <circle
                        cx="10" cy="10" r="8"
                        fill="none"
                        stroke="#4CAF50"
                        strokeWidth="2"
                        strokeDasharray="50.26"
                        strokeDashoffset="50.26"
                        style={{ animation: 'timerFill 3s linear forwards' }}
                        onAnimationEnd={() => setIsTiming(false)}
                    />
                </svg>
            )}
        </div>
    );
};

const Table = ({array, columns, setColumns, componentePadre = ''}) =>{

  const handleMouseDown = (index) => (event) => {
        const startX = event.clientX;
        const startWidth = columns[index].width;
    
        const onMouseMove = (e) => {
          const newWidth = startWidth + (e.clientX - startX);
          setColumns((prevColumns) =>
            prevColumns.map((col, i) =>
              i === index ? { ...col, width: Math.max(newWidth, 50) } : col
            )
          );
        };
    
        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
        };
    
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    };

    const columnsVisibles = useMemo(()=>columns.filter(c => c.visible), [columns]);

    // ot corresponde al objeto de la entidad que se esta renderizando, ej: Orden de Trabajo, Activo, etc...
    const renderCellValue = (row, col, index, ot) => {
        const value = row[col.property];

        if (Array.isArray(value)) return value.length;

        switch (col.property) {
            case 'fecAlt':
            case 'fechaCompletado':
                return value ? value.toString().substring(0, 10) : '';
            case 'fecInicio':
            case 'fecFin':
                return value?.toLocaleString().substring(0, 16).replace("T", " ") ?? '';
            case 'fecha':
                return value.substring(0, 10);
            case 'tipProc':
                return value.label;
            case 'actStatus':
                return value === 'FSERV' ? 'Fuera de Servicio' : 'Disponible';
            case 'done':
                return <span style={{ color: value ? 'green' : 'black', fontWeight: 'bold' }}>
                    {value ? 'Completada' : 'Pendiente'}
                </span>;
            case 'checked':
                return <span style={{ color: value === 'positive' ? 'green' : 'red', fontWeight: 'bold' }}>
                    {value === 'positive' ? 'OK' : 'Fallo'}
                </span>;
            case 'servicioSolicitado':
                return <TimerInput value={value} onChange={(e) => col.setter(index, e.target.value, ot)} />
            case 'comentarios':
                return <TimerInput value={value} onChange={(e) => col.setter(index, e.target.value, ot)} />
            case 'fechaUltimoServicio':
            case 'fechaUltimoRegistro':
            case 'fechaUltimoChecklist':
                return value ? value.toString().substring(0, 10) : '-';
            case 'diasTranscurridos':
                return value != null ? value : '-';
            case 'ultimaLectura':
                return value ? value[col.childProperty] : '';
            case 'ultimalecturaAnterior':
                return value ? value[col.childProperty] : '';
            case 'checkCambioHorometro':
                return <input type="checkbox" value={value} checked={ot.cambioHorometro} onChange={(e) => col.setter(index, e.target.checked, ot)} />
            case 'consumoMensual':
                return row.cambioHorometro ? 'Horometro Cambiado' : value
            default:
                return value;
        }
    }

    return <div className="similTable" style={componentePadre == 'GrillaConsumibles' ? {overflowX:'scroll'} : {}}>
      <div className="columnsHeader">
        {columnsVisibles.map((c,i) => <div className="columnHeader" style={{width: c.width}} key={i}>
          {c.title}
        </div>)}
      </div>
      <div className="rowsData">
        {
          array.map((ot,i) => (<div key={i} className="rowData" style={{borderBottom:  '2px solid black'}}>
              {columnsVisibles.map((c,index) => (<div className="rowDataChild" style={{width: c.width, borderLeft: '2px solid black', borderRight: (index == columnsVisibles.length-1) ? '2px solid black' : '0px', backgroundColor: (typeof ot[c.property] === 'number' && ot[c.property] > 0 && c.property != 'totalConsumed' && !ot?.cambioHorometro) ? 'lightgreen' : undefined}} key={index}>
                  {renderCellValue(ot, c, i, ot)}
              </div>))}
          </div>))
      }
      </div>
      <div className="rowsTotales">
        {columns.map((c,i) => (c.visible) && <div className="rowTotalesChild" style={{width:c.width}}>{(c.totalizator) ? c.value : ''}</div>)}
      </div>
    </div>




//     return <table className="tableReports">
//     <tr className="tableHeader">
//         {columns.map((c,i) => (c.visible) && <th style={{
//           width:`${c.width}px`
//           // flex:1
//           }}>{c.title}<div style={{display: 'inline-block', width: '5px',height:'30px', cursor: 'col-resize',padding: '0 2px'}} onMouseDown={handleMouseDown(i)}/></th>)}
//     </tr>
//     {
//         array.map((ot,i) => (<tr key={i} className="tableChildRow"> 
//             {columns.map((c,index) => (c.visible) && (<th key={index}>
//                 {(Array.isArray(ot[c.property])) ? ot[c.property].length : (c.property == 'fecAlt') ? ot[c.property].toLocaleString().substring(0,16).replace("T", " ") : (c.property == 'fecha') ? ot[c.property].substring(0,10) : (c.property == 'tipProc') ? ot[c.property].label : (c.property == 'actStatus' && ot[c.property] == 'FSERV') ? 'Fuera de Servicio' : (c.property == 'actStatus' && (ot[c.property] == undefined || ot[c.property] == "DISPO")) ? 'Disponible' : ot[c.property]}
//             </th>))} 
//         </tr>))
//     }
//     <tr className="tableTotals">
//         {columns.map((c,i) => (c.visible) && <th style={{width:`${c.width}px`}}>{(c.totalizator) ? c.value : ''}</th>)}
//     </tr>
// </table>

}

export default Table;